import firebase from 'firebase';
import {config as conf} from './config'

export const config = conf;
export const defaultApp = firebase.initializeApp(config);
export const auth = firebase.auth();
export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js